var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 3,
    viewBox: "0 0 12 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M10.5,3A1.5,1.5,0,1,1,12,1.5,1.5,1.5,0,0,1,10.5,3ZM6,3A1.5,1.5,0,1,1,7.5,1.5,1.5,1.5,0,0,1,6,3ZM1.5,3A1.5,1.5,0,1,1,3,1.5,1.5,1.5,0,0,1,1.5,3Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconNew);
export default __webpack_public_path__ + "static/media/warning-icon-new.6019e71481ab3b492dd249580b4af626.svg";
export { ForwardRef as ReactComponent };